import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Group } from '@rocksoft/security-sdk';

export function selectGroupIdfromGroup(group: Group) {
  return group.id;
}

export const adapter: EntityAdapter<Group> = createEntityAdapter<Group>({
  selectId: selectGroupIdfromGroup,
});

export type GroupState = EntityState<Group>;

export const initialState: GroupState = adapter.getInitialState();
